// What an operator reads when a purchase channel is named on screen.
//
// Three of the channels are reseller gateways PEXIFY buys postage through. The
// people who work in the admin see PEXIFY's own short name for them (Volkan
// 2026-09-21) — the gateway's own name stays out of every screen. Nothing else
// is renamed: the ids in code, in the database, in the carrier APIs and in the
// logs are untouched, so a stored row, a saga record or a support call still
// reads the same as before.
//
// Every screen that names a channel spreads this map, so a later rename is one
// edit here.
export const RESELLER_CHANNEL_NAMES: Record<string, string> = {
  avocore: 'Pexship',
  byelabel: 'BL',
  shipdad: 'SD',
}

// The same names as the gateways spell them in their own error text.
const RESELLER_IN_TEXT = /\bavocore\b|\bbye[\s_-]?label\b|\bship[\s_-]?dad\b/gi

/**
 * The rename applied to free text the server wrote — a failed connection test,
 * a refused purchase, a void the carrier rejected. Adapter messages carry the
 * gateway's own name and are printed straight onto an admin screen, so they go
 * through here on the way to the operator.
 */
export function maskProviderNames(text: string): string {
  return text.replace(RESELLER_IN_TEXT, (hit) => {
    const lower = hit.toLowerCase()
    if (lower.startsWith('avocore')) return RESELLER_CHANNEL_NAMES.avocore
    if (lower.startsWith('ship')) return RESELLER_CHANNEL_NAMES.shipdad
    return RESELLER_CHANNEL_NAMES.byelabel
  })
}
